import { FormattedMessage } from 'react-intl';

import { Stack } from '@atlaskit/primitives';

import { Relationships } from '../../types';
import { BaseCard } from '../base-card';
import { CardRelationship } from '../card-relationship';

import { messages } from './messages';

export const FastshiftTeamCard = ({
	isCustomer = false,
	relationships = {},
}: {
	isCustomer?: boolean;
	relationships: Relationships;
}) => {
	return (
		<BaseCard
			message={
				isCustomer
					? messages.fastshiftTeamCardTitleCustomer
					: messages.fastshiftTeamCardTitleInternal
			}
		>
			<Stack space="space.100">
				{relationships.fastshiftChampion && (
					<CardRelationship
						name={relationships.fastshiftChampion.name}
						imageUrl={relationships.fastshiftChampion.imageUrl}
						titleMessage={
							<FormattedMessage {...messages.fastshiftTeamCardCustomerFastshiftChampionTitle} />
						}
					/>
				)}
				{relationships.accountExecutive && (
					<CardRelationship
						name={relationships.accountExecutive.name}
						imageUrl={relationships.accountExecutive.imageUrl}
						titleMessage={<FormattedMessage {...messages.fastshiftTeamCardAccountExecutiveTitle} />}
					/>
				)}
				{relationships.customerSuccessManager && (
					<CardRelationship
						name={relationships.customerSuccessManager.name}
						imageUrl={relationships.customerSuccessManager.imageUrl}
						titleMessage={
							<FormattedMessage {...messages.fastshiftTeamCardCustomerSuccessManagerTitle} />
						}
					/>
				)}
			</Stack>
		</BaseCard>
	);
};
